// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".viso-notification-panel{margin:-40px}.viso-notification-panel__scroll{padding:40px}", "",{"version":3,"sources":["webpack://./app/containers/Notification/Notification.scss"],"names":[],"mappings":"AAAA,yBACE,YAAA,CAEA,iCACE,YAAA","sourcesContent":[".viso-notification-panel {\n  margin: -40px;\n  \n  &__scroll {\n    padding: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
